import React, { ReactElement } from "react";
import { DisclaimerHoofdstuk } from "../../../../.generated/rapportage/rapportagetypes";
import Heading from "../../components/Heading";
import { Paragraph } from "../../components/Paragraph";
import { Chapter } from "../../components/Chapter";

type DisclaimerProps = {
  disclaimer: DisclaimerHoofdstuk;
};

export const DisclaimerChapter = ({
  disclaimer,
}: DisclaimerProps): ReactElement => {
  return (
    <Chapter>
      {disclaimer.titel && (
        <Heading
          text={disclaimer.titel}
        />
      )}
     
      {disclaimer.paragrafen &&
        Object.keys(disclaimer.paragrafen).map((key) => {
          const paragraaf = disclaimer.paragrafen && disclaimer.paragrafen[key];
          return (
            paragraaf && (
                <Paragraph key={key} withMarkdown paragraaf={paragraaf}/>
            )
          );
        })}
    </Chapter>
  );
};
